import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'LeagueSeasonTeam';

const LeagueSeasonTeamApi: any = baseApi(endpoint);

export default LeagueSeasonTeamApi;